<template>
  <div>
    <div class="subtitle mb-5">{{ regTypeField.label }}</div>
    <v-btn v-if="!file" @click="open = !open" color="red" dark rounded class="ma-5">
      <v-icon>mdi-record</v-icon>
    </v-btn>
    <v-btn
      v-if="video"
      color="red"
      @click="
        clear();
        open = true;
      "
      dark
      rounded
    >
      <v-icon>mdi-reload</v-icon>
    </v-btn>

    <v-btn
      v-if="video"
      class="ml-5"
      :href="video"
      color="primary"
      icon
      :download="fileName"
    >
      <v-icon>mdi-download</v-icon>
    </v-btn>
    <div class="mt-5">
      <video v-if="video && play == false" width="200" height="200" @click="clickTumblr">
        <source :src="video + '#t=0.1'" type="video/webm" />
      </video>
      <vue-player
        v-if="video && play == true"
        ref="player"
        style="heght: 350px; width: 200px"
        :src="video"
        v-model="playing"
      >
        <source :src="video + '#t=0.1'" type="video/webm" />
      </vue-player>
    </div>
    <cam-record-dialog v-model="open" @result="onResult"></cam-record-dialog>
  </div>
</template>

<script>
import camRecordDialog from "@/components/dialogs/camRecordDialog";
export default {
  name: "reg-type-field-video-record",
  props: ["value", "regTypeField"],
  components: { camRecordDialog },
  data() {
    return {
      open: false,
      file: null,
      video: "",
      playing: false,
      recording: false,
      play: false,
      fileBase64: null,
      fileName: "video.mp4",
    };
  },
  methods: {
    clear() {
      this.play = false;
      this.fileBase64 = null;
      this.file = null;
      this.playing = false;
      this.video = null;
      this.value.aggregateValue = null;
      this.value.value = null;
    },
    async updateModel(file) {
      if (file == null) {
        this.value.value = null;
        this.value.aggregateValue = null;
      } else {
        this.fileBase64 = await this.$toBase64(this.file, true);
        this.value.value = await this.$toBase64(this.file);
        this.value.aggregateValue = this.fileName;
        this.$forceUpdate();
      }
    },
    async clickTumblr() {
      this.play = true;
      await this.later(500);
      this.playing = true;
    },
    later(delay) {
      return new Promise(function (resolve) {
        setTimeout(resolve, delay);
      });
    },
    clickTeste() {
      let video = this.$refs.video;
      const constraints = {
        video: true,
        audio: true,
      };
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          video.srcObject = stream;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async gravar() {
      this.recording = !this.recording;
      let record = this.$refs.record;
      if (this.recording == true) {
        await record.startRecording();
      } else {
        await record.stop();
      }
    },
    onResult(data) {
      data.lastModifiedDate = new Date();
      data.name = "video.webm";
      this.file = data;
      this.video = window.URL.createObjectURL(data);
      this.updateModel(data);
      this.open = false;
    },
  },
};
</script>

<style></style>
